import React, { useEffect, useState } from 'react';
import PageWrapper from './PageWrapper';
import MainNav from '../nav/MainNav';
import { useTranslation } from 'react-i18next';
import SectionWrapper from '../SectionWrapper';
import api from '../../js/api';
import HtmlContent from '../HtmlContent';

export default function PagePrivacyPolicy() {
    const { t } = useTranslation();
    const [htmlPolicy, setHtmlPolicy] = useState(null);
    
    useEffect(() => {
        fetchData();
    }, []);
    
    const fetchData = async () => {
        try {
            const fetch = await api.get(`privacy-policy`);
            setHtmlPolicy(fetch.data)
        } catch (error) {
            
        }
    }

    return (
        <PageWrapper>
            <SectionWrapper>
                <MainNav pageTitle={t('privacy_policy')}></MainNav>
                {htmlPolicy !== null && <HtmlContent html={htmlPolicy} />}
            </SectionWrapper>
        </PageWrapper>
    )
}
